module.exports = __webpack_public_path__ + "media/images/portugal_center/ferreiradozezere1-397ac19fb69ea24f52c6e22f47052ad4.jpeg";